<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-data-table
    :headers="getClaimsHeaders ()"
    :items="items"
    :loading="loading"
    :total-items="totalItems"
    :items-per-page="rowsPerPage"
    :no-data-text="$t('krita.datagrid.nodata')"
    hide-actions>
    <template v-slot:headers="props">
      <data-grid-sort
        :props="props"
        :pagination="pagination"
        @changeSort="changeSort"
      />
    </template>
    <template v-slot:items="props">
      <td class="text-xs-left"><router-link
        :to="{name: 'Factoring detail', params: {id: props.item.Id}}"
        target="_self">{{ props.item.Id }}</router-link></td>
      <td class="text-xs-left">{{ props.item.DebtorName }} ehf (kt. {{ props.item.DebtorRegistryId | kennitala }})</td>
      <td class="text-xs-left">{{ props.item.FactoringDueDate | date }}</td>
      <td class="text-xs-left">{{ props.item.UsedForRefactoring | amount }}</td>
      <td class="text-xs-right">{{ props.item.RefactoringPaymentDate }}</td>
    </template>
  </v-data-table>
</template>

<script>
import DataGridSort from '../controllers/DataGridSort'
    export default {
        name: "ApplicationDetailRefactoringsDatagrid",
        components: {DataGridSort},
        props: ['loading','items','rowsPerPage', 'totalItems'],
        data () {
            return {
                pagination:
                    {
                        sortBy: 'id'
                    }
            }
        },
        methods: {
            getClaimsHeaders ()
            {
                return [
                    {sortable: true, text: this.$t('krita.common.id'), value: 'Id', align: 'left'},
                    {sortable: true, text: this.$t('krita.common.debtor'), value: 'Debtor', align: 'left'},
                    {sortable: true, text: this.$t('krita.common.facDueDate'), value: 'factoringDueDate', align: 'left'},
                    {sortable: false, text: this.$t('krita.application.refactored'), value: 'refactored', align: 'left'},
                    {sortable: false, text: this.$t('krita.common.paymentDate'), value: 'paymentDate', align: 'right'},
                ]
            },
            changeSort (sort)
            {
                let self = this;

                self.pagination.sortBy = sort.sortBy;
                self.pagination.descending = sort.descending;
                self.$emit('refreshWithSort',self.pagination);
            }
        }
    }
</script>

<style scoped>

</style>